export default (() => {
  if (!global || !global._babelPolyfill) {
    // eslint-disable-next-line global-require
    require('babel-polyfill')
  }
})()
